import { APIRoute } from '@/modules/utils'
import { PartnerQuoteProspect } from '@/data'

export const Route: APIRoute = {
  method: 'POST',
  path: `/v2/partner_quote_prospects`,
}

export type Body = {
  partner: string
}

export type Response = PartnerQuoteProspect
